import React from 'react';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: '30px',
        backgroundColor: '#F6F7FB',
        borderRadius: '0 0 16px 16px',
        padding: '20px 24px',
        width: '100%',
        boxSizing: 'border-box',
        borderTop: '1px solid #E8EAF4',
        font: 'inherit',
        textAlign: 'left'
    },
    squareBottom: {
        borderRadius: 0
    },
    expandable: {
        border: 'none',
        cursor: 'pointer'
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        backgroundColor: '#E8EAF4',
        borderRadius: '50%',
        color: '#A6A6BF',
        minWidth: '40px',
        height: '40px',
        flexShrink: 0,
        '& i': {
            fontSize: '16px',
            lineHeight: 1
        }
    },
    content: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: '6px'
    },
    titleRow: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '8px'
    },
    title: {
        fontSize: '20px',
        fontWeight: 700,
        lineHeight: '27px',
        color: '#A6A6BF'
    },
    pill: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#E8EAF4',
        borderRadius: '999px',
        color: '#A6A6BF',
        fontSize: '12px',
        fontWeight: 800,
        padding: '4px 8px',
        width: 'fit-content'
    },
    description: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '22px',
        color: '#A6A6BF',
        textAlign: 'left'
    },
    chevron: {
        fontSize: '16px',
        color: '#A6A6BF',
        flexShrink: 0
    }
}));

type LockedSummaryProps = {
    description: string;
    onExpand?: () => void;
    pillText?: string;
    roundedBottom?: boolean;
    title: string;
};

const LockedSummary: React.FC<LockedSummaryProps> = ({
    description,
    onExpand,
    pillText,
    roundedBottom = true,
    title
}) => {
    const classes = useStyles();
    const Container = onExpand ? 'button' : 'div';

    return (
        <Container
            className={`${classes.container} ${onExpand ? classes.expandable : ''} ${roundedBottom ? '' : classes.squareBottom}`}
            onClick={onExpand}
            type={onExpand ? 'button' : undefined}
        >
            <div className={classes.icon}>
                <i className="fas fa-lock" />
            </div>
            <div className={classes.content}>
                <div className={classes.titleRow}>
                    <span className={classes.title}>{title}</span>
                    {pillText ? (
                        <span className={classes.pill}>{pillText}</span>
                    ) : null}
                </div>
                <span className={classes.description}>{description}</span>
            </div>
            {onExpand ? (
                <i className={`fas fa-chevron-down ${classes.chevron}`} />
            ) : null}
        </Container>
    );
};

export default LockedSummary;
